module.exports = __webpack_public_path__ + "img/JAOC_POP_PizzaMaker_Incorrect.9f271615.png";